const shopUrl = window.Shopify?.routes?.root || "/";
const stampedStars = document.querySelectorAll('.product-meta__reviews .stamped-main-badge.stamped-stars-only');
const stampedCount = document.querySelectorAll('.product-meta__reviews .stamped-main-badge.stamped-count-only');
const stampedAverage = document.querySelectorAll('.product-meta__reviews .stamped-reviews_average');

//Novel UGC
const OVERLAY_EMBED_TYPE_UNIQUE_NAME = 'overlay';
const apiBaseUrl = 'https://eg2o7r7cs9.execute-api.us-west-2.amazonaws.com/prod';
const embedJsUrl = 'https://embed-js.benovel.com/embed/index.js';

document.addEventListener('DOMContentLoaded', async () => {
  const productBlocks = document.querySelectorAll('.section-product-picker .ftrp--product-block');
  const selectedProductBlock = document.querySelector('.section-product-picker .ftrp--product-block.is-selected');

  if(selectedProductBlock) {
    const productHasOnlyDefaultVariant = selectedProductBlock.dataset.hasOnlyDefaultVariant == 'true' ? true : false;
    let variant_data;
    if(productHasOnlyDefaultVariant) {
      variant_data = {
        id: selectedProductBlock.dataset.variantId,
        name: selectedProductBlock.dataset.title,
        available: selectedProductBlock.dataset.variantAvailable,
      };
    }
    klBackInStock(productHasOnlyDefaultVariant, variant_data);
  }

  if(novel_ids && selectedProductBlock.dataset.pid) loadNovelWidget(selectedProductBlock.dataset.pid);

  productBlocks.forEach(block => {
    block.addEventListener('click', async () => {
      const handle = block.dataset.handle;
      const productId = block.dataset.pid;
      const productTitle = block.dataset.title;
      const productFeaturedImage = block.dataset.featuredImage;
      const productHasOnlyDefaultVariant = block.dataset.hasOnlyDefaultVariant == 'true' ? true : false;
      let variant_data;

      document.querySelectorAll('.product-picker--item.product-selected').forEach(el => el.classList.remove('product-selected'));
      block.querySelector('.product-picker--item')?.classList.add('product-selected');
      
      await loadNewProductSection(handle, 'MainProductSection', productId);
      await loadNewProductSection(handle, 'productMediaBanners');
      await loadNewProductSection(handle, 'productComparison');

      updateShopifyProductContext({ productId, handle });
      const productChangeEvent = new CustomEvent('product-nav:changed', {
        detail: {
          handle: handle,
          productId: productId
        }
      });
      document.dispatchEvent(productChangeEvent);      

      updateStampedStarRating({
        reviewAverage: block.dataset.stampedAverage,
        productId: productId,
        productHandle: handle,
        productTitle: productTitle
      });

      //Re-init faq accordions
      $('.accordion-new').on('click', '.heading-new', function () {
        $('.heading-new').not(this).removeClass('active');
        $(this).toggleClass('active').next().slideToggle();
        $('.contents-new').not($(this).next()).slideUp(300);
      });

      //Re-load Novel widget      
      if(novel_ids) loadNovelWidget(productId);
      
      //Re-init upsell products
      $('.product-recommendations-slider').not('.slick-initialized').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        arrows:false
      });

      updateProductComparison();

      updateStampedMainWidget({
        id: productId,
        handle: handle,
        title: productTitle,
        featuredImage: productFeaturedImage
      });

      if(productHasOnlyDefaultVariant) {
        variant_data = {
          id: block.dataset.variantId,
          name: productTitle,
          available: block.dataset.variantAvailable,
        };
      }
      klBackInStock(productHasOnlyDefaultVariant, variant_data);
    });
  });
});

async function loadNewProductSection(handle, secId, productId = null) {
  const oldSectionWrapper = document.getElementById(secId);
  if (!oldSectionWrapper) return;

  const sectionId = oldSectionWrapper.dataset.sectionId;
  const currentUrl = new URL(window.location.href);

  // 1. Construct the URL to fetch the new product's HTML
  const fetchUrl = new URL(`${window.Shopify?.routes?.root || '/'}products/${handle}`, window.location.origin);
  
  // Crucial: Tell Shopify to return only the single section's HTML
  fetchUrl.searchParams.set('section_id', sectionId);

  try {
    // 2. Add visual transition (Fade out old content)
    oldSectionWrapper.style.transition = 'opacity 0.3s ease-in-out';
    oldSectionWrapper.style.opacity = '0.5';
    oldSectionWrapper.style.pointerEvents = 'none'; // Prevent clicks during loading

    // 3. Fetch the content
    //const response = await fetch(fetchUrl);
    const response = await fetch(fetchUrl.toString());
    const html = await response.text();

    // 4. Parse the HTML and extract the new section
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newSection = doc.getElementById(secId);

    if (!newSection) {
      console.error('New product section not found in fetched HTML.');
      // Revert opacity on fail
      oldSectionWrapper.style.opacity = '1'; 
      oldSectionWrapper.style.pointerEvents = 'auto';
      return;
    }

    // 5. Swap the content
    oldSectionWrapper.replaceWith(newSection);

    // 6. Update URL (SEO and History)
    // Update the pathname to the new product handle
    currentUrl.pathname = `/products/${handle}`; 
    currentUrl.searchParams.delete('variant'); 
    // Remove the section_id parameter to keep the final URL clean
    currentUrl.searchParams.delete('section_id'); 
    
    history.pushState(null, '', currentUrl.toString());

    // 7. Add visual transition (Fade in new content)
    requestAnimationFrame(() => {
      newSection.style.transition = 'opacity 0.5s ease-in-out';
      newSection.style.opacity = '1';
      newSection.style.pointerEvents = 'auto';      
    });

    if(secId === 'MainProductSection' && productId) {
      window.dynamaticLoadWidget();
    }
  } 
  catch (error) {
    console.error('PDP Section Swap Failed:', error);
  }
}

function updateStampedStarRating(data) {
    stampedStars.forEach(el => {
        el.dataset.id = data.id;
        el.dataset.productSku = data.handle;
        el.dataset.productTitle = data.title;
    });

    stampedCount.forEach(el => {
        el.dataset.id = data.id;
        el.dataset.productSku = data.handle;
        el.dataset.productTitle = data.title;
    });

    if (stampedAverage && data.reviewAverage) {
        stampedAverage.forEach(el => {
            el.innerText = data.reviewAverage;
        });
    }

    if (window.StampedFn && typeof window.StampedFn.loadBadges === "function") {
        window.StampedFn.loadBadges();
    }
}

function getNovelId(productId) {
  const item = novel_ids.find(obj => obj[productId]);
  return item ? item[productId] : null;
}

async function loadNovelWidget(productId) {
  const embedElem = document.getElementById('novelUGCEmbed');
  const journeyId = getNovelId(productId);
  
  const loadEmbedScript = (release) => {
    window[`prefetchedJourneyRelease_${journeyId}`] = release

    const script = document.createElement('script');
    script.setAttribute('src', embedJsUrl);
    script.setAttribute('journey-id', journeyId);
    script.setAttribute('async', '');
    if(script) {
        embedElem.innerHTML = '';
        embedElem.appendChild(script);
    }
  };

  const response = await fetch(
  `${apiBaseUrl}/api/v2/journeys/${journeyId}/releases?type=PUBLISH&sort=createdAt&order=DESC&size=1`,
  )
  const releases = await response?.json();
  try {
    loadEmbedScript(releases[0])
  } catch (error) {
    console.log(error);
  }
}

function updateStampedMainWidget(data) {
  const widgetEl = document.getElementById("stamped-main-widget");
  if (!widgetEl || !data) return;

  widgetEl.setAttribute("data-product-id", data.id);
  widgetEl.setAttribute("data-name", data.title);
  widgetEl.setAttribute("data-url", `${shopUrl}/products/${data.handle}`);
  widgetEl.setAttribute("data-image-url", data.featuredImage);
  widgetEl.setAttribute("data-product-sku", data.handle);

  if(window.StampedFn) {
    window.StampedFn.reloadUGC();
  }
}

function updateProductComparison() {
  $('.compare_product_section .product_item span.title').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).next().toggle();
  });

  $('.pro_title_dropmenu li').on('click', function () {
    if($('.product-comparison--details').css('display') == 'none') {
      $('.product-comparison--details').css('display','grid');
    }
    const d_id = $(this)[0].dataset.id;
    const product_title = $(this)[0].dataset.title;
    const productUrl = $(this)[0].dataset.url || '#';
    const productImgUrl = $(this)[0].dataset.img;
    const ddl_name = $(this)[0].closest('.pro_title_dropmenu').dataset.name;
    const container = document.querySelector(`.product-comparison--details .product_grid--item[data-name="${ddl_name}"]`);
    container.innerHTML = "";
    const result = getProductFeatures(d_id, ddl_name);
    const productImg = document.querySelector(`.product_grid--control[data-name="${ddl_name}"] .product-comparison--img`);

    if(productImgUrl) {
      productImg.src = productImgUrl;
    }
    
    result.forEach(item => {
      const valueDiv = document.createElement('div');
      
      if(item.feature_title == 'What’s Included') {
        const listElement = createListFromString(item.value);
        valueDiv.appendChild(listElement);
      }
      else {
        valueDiv.textContent = item.value;
      }
      valueDiv.classList.add('pcomparison--value');
      valueDiv.classList.add(`pcomparison--${handleize(item.feature_title)}`);
      container.appendChild(valueDiv);
    });

    const shopDiv = document.createElement('div');
    shopDiv.classList.add('pcomparison--value');
    shopDiv.classList.add('pcomparison--cta');
    shopDiv.innerHTML = `
      <a href="${productUrl}" class="shop_btn"><small>Shop ${product_title}</small></a>
    `;
    container.appendChild(shopDiv);
  });
}


function klBackInStock(hasOnlyDefaultVariant = false, variant_data = undefined) {
  const klBisBtn = document.querySelector('.kl-bis-api');
  const bisVariantId = document.querySelector('#klaviyo_bis_form #variant_id_input');
  const bisVariantName = document.querySelector('#klaviyo_bis_form #variant_name');

  if(klBisBtn) {
    if(hasOnlyDefaultVariant && variant_data) {
      klBisBtn.style.display = variant_data.available == 'false' ? 'block' : 'none';
      bisVariantId.value = variant_data.id;
      bisVariantName.innerText = variant_data.name;
    }
    else {
      document.addEventListener("variant:changed", function (event) {
        const variant = event.detail.variant;
        if(variant) {
          klBisBtn.style.display = variant.available == false ? 'block' : 'none';
          bisVariantId.value = variant.id;
          bisVariantName.innerText = variant.name;
        }
      });
    }
    
  }
}


function updateShopifyProductContext({ productId, handle }) {
  // ShopifyAnalytics
  if (window.ShopifyAnalytics?.meta) {
    window.ShopifyAnalytics.meta.product = {
      id: Number(productId),
      handle: handle
    };
  }

  // window.meta fallback
  if (window.meta) {
    window.meta.product = {
      id: Number(productId),
      handle: handle
    };
  }

  // Shopify global (safe no-op if unused)
  if (window.Shopify) {
    window.Shopify.product = {
      id: Number(productId),
      handle: handle
    };
  }
}
